import React, { useEffect, useState } from 'react';
import logo from './../assets/logo.png';
import { useAuth } from '../auth/useAuth';

function Header({ onNavigate }) {
  const [activeCategory, setActiveCategory] = useState('');
  const [activeButton, setActiveButton] = useState('');
  const { user, logout } = useAuth();

  useEffect(() => {
    const logoImg = document.getElementById('logo-image');
    if (logoImg) {
      logoImg.src = logo;
    }

    // Use sessionStorage instead of localStorage for UI state
    const savedCategory = sessionStorage.getItem('activeCategory');
    const savedButton = sessionStorage.getItem('activeButton');

    if (savedCategory) setActiveCategory(savedCategory);
    if (savedButton) setActiveButton(savedButton);
  }, []);

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setActiveButton('');
    sessionStorage.setItem('activeCategory', category);
    onNavigate(category);
  };

  const handleButtonClick = (buttonPath) => {
    setActiveButton(buttonPath);
    sessionStorage.setItem('activeButton', buttonPath);
    onNavigate(buttonPath);
  };

  const handleLogoClick = () => {
    setActiveCategory('');
    setActiveButton('');
    sessionStorage.removeItem('activeCategory');
    sessionStorage.removeItem('activeButton');
    onNavigate('/');
  };

  return (
    <header>
      <div className="top-section">
        <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img id="logo-image" alt="iAssess Logo" />
        </div>
        <div className="header-text">
          <h2>iAssess</h2>
          <p>Skill Assessment Platform</p>
        </div>

        {/* User info + logout — shown when authenticated */}
        {user && (
          <div className="header-user-section">
            <div className="header-user-info">
              <span className="header-user-avatar" aria-hidden="true">
                {user.name ? user.name.charAt(0).toUpperCase() : '?'}
              </span>
              {/* <div className="header-user-details">
                <span className="header-user-name">{user.name}</span>
                <span className="header-user-email">{user.email}</span>
              </div> */}
            </div>
            <button
              className="header-logout-btn"
              onClick={logout}
              title="Sign out"
              aria-label="Sign out"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Sign out
            </button>
          </div>
        )}
      </div>

      <div>
        <div className="categories">
          {/* Resume Processing */}
          <div
            className={`category-card ${activeCategory === '/resume-scan' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('/resume-scan')}
          >
            <h2>Resume Scanning</h2>
            <p>Scan and manage candidate resumes.</p>
          </div>

          {/* TAG Assessment */}
          <div
            className={`category-card ${activeCategory === '/tag-screening' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('/tag-screening')}
          >
            <h2>TAG Screening</h2>
            <p>To Perform initial technical screening at TAG level.</p>
          </div>

          {/* Assessments */}
          <div
            className={`category-card ${activeCategory === '/new-user' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('/new-user')}
          >
            <h2>Assessments</h2>
            <p>Manage candidate assessments and evaluations.</p>
          </div>

          {/* Question Management */}
          <div
            className={`category-card ${activeCategory === '/sample-questions' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('/sample-questions')}
          >
            <h2>Question Management</h2>
            <p>Create and manage question banks.</p>
          </div>

          {/* Search */}
          <div
            className={`category-card ${activeCategory === '/existing-user' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('/existing-user')}
          >
            <h2>Search</h2>
            <p>View existing assessments and metrics.</p>
          </div>
        </div>

        {/* Conditional sub-buttons for Assessments */}
        {activeCategory === '/assessments' && (
          <div className="assessment-buttons">
            <button
              className="assessment-button"
              style={{ backgroundColor: activeButton === '/new-user' ? 'orange' : '' }}
              onClick={() => handleButtonClick('/new-user')}
            >
              Candidate Assessment
            </button>
            <button
              className="assessment-button"
              style={{ backgroundColor: activeButton === '/live-assessment' ? 'orange' : '' }}
              onClick={() => handleButtonClick('/live-assessment')}
            >
              Live Assessment
            </button>
            <button
              className="assessment-button"
              style={{ backgroundColor: activeButton === '/existing-user' ? 'orange' : '' }}
              onClick={() => handleButtonClick('/existing-user')}
            >
              Existing Assessments
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
